//RUTAS EMPRESAS
//--gam
export const urlGetCompanies = "/api/companies";
export const urlCreateCompanies = "/api/companies";
export const urlEditCompanies = "/api/companies";